import _defineProperty from "/root/v3si_nodejs_projects/src/nodejs_vscan_service/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/root/v3si_nodejs_projects/src/nodejs_vscan_service/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function getBlobFromImageSource(imageSource) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(imageSource));

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.blob();

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function isJpegBlob(blob) {
  return blob.type.includes('jpeg');
}

function isPngBlob(blob) {
  return blob.type.includes('png');
}

function createImageElement(imageSource) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var imageElement = document.createElement('img');
              imageElement.crossOrigin = 'anonymous';
              imageElement.src = imageSource;

              imageElement.onload = function (event) {
                var target = event.target;
                resolve(target);
              };

              imageElement.onabort = reject;
              imageElement.onerror = reject;
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

function getBlobFromImageElement(imageElement) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var canvas = document.createElement('canvas');
              var context = canvas.getContext('2d');

              if (context) {
                var width = imageElement.width,
                    height = imageElement.height;
                canvas.width = width;
                canvas.height = height;
                context.drawImage(imageElement, 0, 0, width, height);
                canvas.toBlob(function (blob) {
                  if (blob) resolve(blob);else reject('Cannot get blob from image element');
                }, 'image/png', 1);
              }
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

function convertBlobToPng(imageBlob) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var imageSource, imageElement;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            imageSource = URL.createObjectURL(imageBlob);
            _context4.next = 3;
            return createImageElement(imageSource);

          case 3:
            imageElement = _context4.sent;
            _context4.next = 6;
            return getBlobFromImageElement(imageElement);

          case 6:
            return _context4.abrupt("return", _context4.sent);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

function copyBlobToClipboard(blob) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var items, clipboardItem;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            items = _defineProperty({}, blob.type, blob);
            clipboardItem = new ClipboardItem(items);
            _context5.next = 4;
            return navigator.clipboard.write([clipboardItem]);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

function copyImageToClipboard(imageSource) {
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var blob, pngBlob;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getBlobFromImageSource(imageSource);

          case 2:
            blob = _context6.sent;

            if (!isJpegBlob(blob)) {
              _context6.next = 12;
              break;
            }

            _context6.next = 6;
            return convertBlobToPng(blob);

          case 6:
            pngBlob = _context6.sent;
            _context6.next = 9;
            return copyBlobToClipboard(pngBlob);

          case 9:
            return _context6.abrupt("return", blob);

          case 12:
            if (!isPngBlob(blob)) {
              _context6.next = 16;
              break;
            }

            _context6.next = 15;
            return copyBlobToClipboard(blob);

          case 15:
            return _context6.abrupt("return", blob);

          case 16:
            throw new Error('Cannot copy this type of image to clipboard');

          case 17:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

function requestClipboardWritePermission() {
  var _a;

  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var _ref, state;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.permissions) === null || _a === void 0 ? void 0 : _a.query) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", false);

          case 2:
            _context7.next = 4;
            return navigator.permissions.query({
              name: 'clipboard-write'
            });

          case 4:
            _ref = _context7.sent;
            state = _ref.state;
            return _context7.abrupt("return", state === 'granted');

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
}

function canCopyImagesToClipboard() {
  var _a;

  var hasFetch = typeof fetch !== 'undefined';
  var hasClipboardItem = typeof ClipboardItem !== 'undefined';
  var hasNavigatorClipboardWriteFunction = !!((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.write);
  return hasFetch && hasClipboardItem && hasNavigatorClipboardWriteFunction;
}

export { canCopyImagesToClipboard, convertBlobToPng, copyBlobToClipboard, copyImageToClipboard, createImageElement, getBlobFromImageElement, getBlobFromImageSource, isJpegBlob, isPngBlob, requestClipboardWritePermission };